/* Copyright(c) 2018, iovation, inc. All rights reserved. */
window.io_global_object_name = "IGLOO"
window.IGLOO = window.IGLOO || {
  "enable_flash" : false,
  "bbout_element_id" : "ioBlackBox",  // this can be changed to store in a different hidden field (or removed to use a different collection method)
  "loader" : {
    "subkey"  : "i07bAlexpwOuUoOhI2Z81QL0xKnFrxmVSbWC7Ar-XH4",
    "version" : "general5"
  }
};